import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";
import { Mail, Github, Linkedin, ArrowUpRight } from "lucide-react";

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="pt-24 md:pt-32 lg:pt-48 pb-16 border-t border-white/10">
      <Reveal className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <p className="text-xs uppercase tracking-[0.25em] text-[#71717A] font-mono-alt">Contact</p>
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.05] font-medium text-[#F9F9F9] mt-6 max-w-4xl">
          Have something interesting in mind?
        </h2>
        <p className="text-base md:text-lg text-[#A1A1AA] mt-8 max-w-2xl leading-relaxed">
          I’m always interested in connecting with people who build, experiment, and think
          differently.
        </p>
        <p className="text-base md:text-lg text-[#A1A1AA] mt-4 max-w-2xl leading-relaxed">
          If you’re working on an interesting problem, exploring an ambitious idea, or looking to
          collaborate, let’s talk.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex flex-wrap items-center gap-4 mt-12">
          <a
            data-testid="contact-email-button"
            href="mailto:cvirat719@gmail.com"
            className="inline-flex items-center gap-2.5 bg-[#F9F9F9] text-[#080808] px-8 py-4 text-sm font-medium rounded-full hover:bg-[#0EA5E9] transition-colors duration-300"
          >
            <Mail size={16} />
            cvirat719@gmail.com
          </a>
          <a
            data-testid="contact-github-link"
            href="#"
            aria-disabled="true"
            title="GitHub — link coming soon"
            className="inline-flex items-center gap-2 border border-white/20 text-[#A1A1AA] px-8 py-4 text-sm font-medium rounded-full hover:border-[#0EA5E9] hover:text-[#0EA5E9] transition-colors duration-300"
          >
            <Github size={16} />
            GitHub
            <span className="text-[10px] uppercase tracking-[0.12em] text-[#71717A]">Soon</span>
          </a>
          <a
            data-testid="contact-linkedin-link"
            href="#"
            aria-disabled="true"
            title="LinkedIn — link coming soon"
            className="inline-flex items-center gap-2 border border-white/20 text-[#A1A1AA] px-8 py-4 text-sm font-medium rounded-full hover:border-[#0EA5E9] hover:text-[#0EA5E9] transition-colors duration-300"
          >
            <Linkedin size={16} />
            LinkedIn
            <span className="text-[10px] uppercase tracking-[0.12em] text-[#71717A]">Soon</span>
          </a>
        </div>
      </Reveal>

      <Reveal delay={0.25} className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <footer data-testid="site-footer" className="mt-24 md:mt-32 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-sm text-[#71717A]">Designed and built by Virat Chaudhary.</p>
          <p className="text-sm text-[#71717A] font-mono-alt">© {new Date().getFullYear()}</p>
          <button
            data-testid="back-to-top"
            onClick={() => scrollToId("top")}
            className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] text-[#71717A] hover:text-[#F9F9F9] transition-colors"
          >
            Back to top <ArrowUpRight size={13} className="-rotate-45" />
          </button>
        </footer>
      </Reveal>
  </section>
);
